import jq from "jquery";
import md5 from 'js-md5';
import store from "@/store";
export default {
  requestWithContentType: function (url, params, type, dataType) {
    return jq.ajax({
      type: type ? type : 'post',
      url: process.env.VUE_APP_API_PREFIX + url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: params,
      dataType: dataType ? dataType : 'json'
    });
  },
  requestWithContentTypeAndToken: function (url, params, type, dataType,contentType) {
    let time = new Date().getTime();
    let str = "hbrb-app-amc$" + time;
    str = md5(str);
    str = "h5Client-id$" + str + "$" + time;
    str = md5(str);

    return jq.ajax({
      type: type ? type : 'post',
      url: process.env.VUE_APP_API_PREFIX + url,
      headers: {
        'Content-Type': contentType ? contentType : 'application/json',
        token: str,
        requestTime: time,
      },
      data: params,
      dataType: dataType ? dataType : 'json'
    });
  },
  requestWithToken: function (url, params, type, dataType) {
    let time = new Date().getTime();
    let str = "hbrb-app-amc$" + time;
    str = md5(str);
    str = "h5Client-id$" + str + "$" + time;
    str = md5(str);

    return jq.ajax({
      type: type ? type : 'post',
      url: process.env.VUE_APP_API_PREFIX + url,
      headers: {
        token: str,
        requestTime: time,
      },
      data: params,
      dataType: dataType ? dataType : 'json'
    });
  },
  requestWithMd5: function (url, params, type, dataType) {
    let crypto = require("crypto");
    let userInfo=localStorage.getItem("userInfo")
    let isSupportsLocalStorage=supportsLocalStorage();
    
    if(!isSupportsLocalStorage || !userInfo || !userInfo.id){
      let timestamp = Date.now();
      delete params.fromFlag;
      delete params.fromFlag;
      console.log('isSupportsLocalStorage:');
      let signature=this.genSignatureMd5(timestamp,params,crypto);
      return jq.ajax({
        type: type ? type : 'post',
        url: process.env.VUE_APP_API_PREFIX + url,
        headers: {
          signature: signature,
          timestamp: timestamp,
        },
        data: params,
        dataType: dataType ? dataType : 'json'
      });
    }
    else{
      this.requestWithToken(url, params, type, dataType);
    }
    function supportsLocalStorage() {
      try {
        // 设置一个测试项
        localStorage.setItem('test', '1');
        // 获取这个测试项并删除
        localStorage.removeItem('test');
        // 返回true表示支持
        return true;
      } catch (e) {
        // 返回false表示不支持
        return false;
      }
    }
  },
  genSignatureMd5(sourceKey, params,crypto){
    let me=this; 
    // 1. 参数名按照ASCII码表升序排序  
    const keys = Object.keys(params).sort();  
    // 2. 按照排序拼接参数名与参数值  
    let sb = '';  
    keys.forEach(key => {  
      const value = params[key];  
      if (value !== null && value !== undefined) {  
          if (typeof value === 'object' && value !== null) {  
              // 假设value是对象或数组，我们递归处理  
              if (Array.isArray(value)) {  
                  // 处理数组，这里假设数组元素也是对象，且需要递归处理  
                  value.forEach(item => {  
                      if (typeof item === 'object' && item !== null) {  
                          sb += me.genSignatureMd5(sourceKey, item,crypto);  
                      }  
                  });  
              } else {  
                  sb += me.genSignatureMd5(sourceKey, value,crypto);  
              }  
          } else {  
              // 直接拼接key和value  
              sb += `${key}${value}`;  
          }  
      }  
    });  
  
    // 3. 将secretKey拼接到最后  
    sb += sourceKey;  
  
    console.log(`sbStr = ${sb}`);  
  
    // 4. MD5加密  
    return crypto.createHash('md5').update(sb, 'utf8').digest('hex'); 
  },
  requestWithTokenAndAuthorization: function (url, params, type, dataType) {
    var token = window.localStorage.getItem("accessToken");
    let tokenTime = window.localStorage.getItem("tokenTime");
    var expiresIn = window.localStorage.getItem("expiresIn");

    let time = new Date().getTime();
    let str = "hbrb-app-amc$" + time;
    str = md5(str);
    str = "h5Client-id$" + str + "$" + time;
    str = md5(str);

    if (!!token && (time - parseInt(tokenTime) > (parseInt(expiresIn) - 5) * 1000)) {
      // 刷新token后请求
      return this.refreshToken().then((token) => {
        return jq.ajax({
          type: type ? type : 'post',
          url: process.env.VUE_APP_API_PREFIX + url,
          headers: {
            token: str,
            requestTime: time,
            Authorization: "Bearer " + token,
          },
          data: params,
          dataType: dataType ? dataType : 'json'
        });
      })
    } else {
      return jq.ajax({
        type: type ? type : 'post',
        url: process.env.VUE_APP_API_PREFIX + url,
        headers: {
          token: str,
          requestTime: time,
          Authorization: "Bearer " + token,
        },
        data: params,
        dataType: dataType ? dataType : 'json'
      });
    }
  },
  requestWithAuthorization: function (url, params, type, dataType) {
    var token = window.localStorage.getItem("accessToken");
    let tokenTime = window.localStorage.getItem("tokenTime");
    var expiresIn = window.localStorage.getItem("expiresIn");

    let time = new Date().getTime();

    if (!!token && (time - parseInt(tokenTime) > (parseInt(expiresIn) - 5) * 1000)) {
      // 刷新token后请求
      return this.refreshToken().then((token) => {
        return jq.ajax({
          type: type ? type : 'post',
          url: process.env.VUE_APP_API_PREFIX + url,
          headers: {
            Authorization: "Bearer " + token,
          },
          data: params,
          dataType: dataType ? dataType : 'json'
        });
      });
    } else {
      return jq.ajax({
        type: type ? type : 'post',
        url: process.env.VUE_APP_API_PREFIX + url,
        headers: {
          Authorization: "Bearer " + token,
        },
        data: params,
        dataType: dataType ? dataType : 'json'
      });
    }
  },
  refreshToken: function () {
    return new Promise((resolve, reject) => {
      return store.dispatch("app/RefreshToken").then(res => {
        resolve(res.data.accessToken)
      });
    });
  }
}